import { render, staticRenderFns } from "./PriceWidget.vue?vue&type=template&id=8a642502&scoped=true"
import script from "./PriceWidget.vue?vue&type=script&lang=js"
export * from "./PriceWidget.vue?vue&type=script&lang=js"
import style0 from "./PriceWidget.vue?vue&type=style&index=0&id=8a642502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a642502",
  null
  
)

export default component.exports